import { ApiError, type Member, type Role, type Uuid } from "@shared/api";
import type { Rights } from "@features/moderate-member";

/** Вкладки полного профиля — как в Discord: активность, общие друзья, общие серверы. */
export type ProfileTab = "activity" | "friends" | "servers";

/**
 * Сервер, где смотрят профиль, — как во всплывающем профиле Discord: роли
 * человека на нём, ник, когда пришёл. Нет — профиль без сервера (переписка).
 */
export interface ProfileServer {
  id: Uuid;
  name: string;
  iconId: Uuid | null;
  /** Участие этого человека; `null` — он не на сервере. */
  member: Member | null;
  roles: readonly Role[];
  /** Мои права здесь: по ним крестик у роли и «+». */
  rights: Rights | null;
  onRole: (roleId: Uuid, on: boolean) => void;
}

/** Почему не открылась переписка — одной строкой для человека. */
export function dmProblem(error: unknown): string {
  return error instanceof ApiError && error.code === "dms_closed"
    ? "Этот человек принимает личные сообщения только от друзей."
    : error instanceof ApiError
      ? error.message
      : "Не получилось открыть переписку";
}
